import { CarbonIntensityState } from 'src/modules/carbon-intensity/types/CarbonIntensityState';
import { RootState } from 'src/types/RootState';

export function getCarbonIntensityState(state: RootState): CarbonIntensityState {
  return state.carbonIntensity;
}
